export const MenuItems=[
    {
        title:"Home",
        url:"/home",
        cName:"nav-links",
        icons:"fa-solid fa-house-chimney"
    },
    {
        title:"About",
        url:"/about",
        cName:"nav-links",
        icons:"fa-solid fa-circle-info"
    },
    {
        title:"Service",
        url:"/service",
        cName:"nav-links",
        icons:"fa-solid fa-briefcase"
    },
    {
        title:"Contact",
        url:"/contact",
        cName:"nav-links",
        icons:"fa-solid fa-address-book"
    },
    {
        title:"Sign Up",
        url:"/Signup",
        cName:"nav-links-mobile",
    },
    
]